export default __webpack_public_path__ + "static/media/d25.75f8c32d.jpeg";